package org.hs_soft.runmynesto.domain.model.home.product.tabs.tab_price.special_price


import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class CashAssist(
    @SerialName("getSpecialPrice")
    val getSpecialPrice: GetSpecialPrice?=null,
    @SerialName("updateSpecialPrice")
    val updatedPrice:GetSpecialPrice?=null,
    @SerialName("createSpecialPrice")
    val createSpecialPrice:GetSpecialPrice?=null,
    @SerialName("__typename")
    val typename: String?
)